import { sect } from "./virtel-consts";
import { js_utils } from '../utils/frfr-js-utils.js';
import { _sema_default_fields } from './ter-virtel-definition-lib.js';


// VIRT UTILS


export const _update_virtelArr_with_genus_ident = (_virtelArr, virtel_subkey_plus_genus_ident_arr) => {
  if (Array.isArray(virtel_subkey_plus_genus_ident_arr)) {
    const updated_virtelArr = _virtelArr.map((virtel) => {
      let genus_ident;
      virtel_subkey_plus_genus_ident_arr.forEach((gi) => {
        if (gi && gi.subkey && gi.subkey === virtel.subkey) {
          genus_ident = gi.genus_ident;
        }
      });
      const updated_virtel = {
        ...virtel,
        genus_ident
      };
      return updated_virtel;
    });
    return updated_virtelArr;
  } else {
    return _virtelArr;
  }
};


const _virtel_graphpath_to_arr = (path) => {
  // /terkk$klimakomora/terkk$modul/profil_' + key
  const SLASH = '/';
  let path_arr = [];
  let _path_arr = path.split(SLASH);
  _path_arr.forEach((item, index) => {
    if (index === 1 || index === (_path_arr.length - 1)) {
      if (item !== '') {
        // ako prvi ili poslednji item nije prazan string
        path_arr.push(item);
      }
    } else {
      // svi ostali koji nisu prvi i poslednji
      path_arr.push(item);
    }
  });
  return path_arr
};

export const _virtel_graphpath_get_self = (path) => {
  //
  let path_arr = _virtel_graphpath_to_arr(path);
  return path_arr[path_arr.length - 1]; // return last item
};


export const _get_arr_of_keys_sorted_by_sema = (obj, sema) => {
  // console.log(obj);
  // console.log(sema);
  let sorted = [];
  let _used_keys = {};
  if (sema && Array.isArray(sema.fields)) {
    const sema_fields = [
      ...sema.fields
    ];
    // console.log(sema_fields);
    // pre svih
    sorted.push('graphlevel');
    sorted.push('bomlevel');
    sorted.push('graphpath');
    sorted.push('subkey');
    sorted.push('parent_subkey');
    _used_keys['graphlevel'] = true;
    _used_keys['bomlevel'] = true;
    _used_keys['graphpath'] = true;
    _used_keys['subkey'] = true;
    _used_keys['parent_subkey'] = true;
    //
    sema_fields.forEach((field) => {
      let field_name;
      if (typeof field === 'string') {
        field_name = field;
      } else {
        field_name = field.name;
      }
      if (_used_keys[field_name] !== true) {
        if (obj[field_name]) {
          sorted.push(field_name);
        }
        _used_keys[field_name] = true; // setujemo bas true da bi lakse detektovali viskove malo kasnije
      }
    });
  }
  // i sad dodajemo jos i viskove na kraj array-a
  Object.keys(obj).forEach((field_name) => {
    if (_used_keys[field_name] === true) {
    } else {
      sorted.push(field_name);
    }
  });
  return sorted;
};


export const _get_fixed_fields = (sema) => {
  if (js_utils.is_object(sema.fixed_fields)) {
    return {
      ...sema.fixed_fields
    };
  }
  return {};
};


export const _get_sect_by_fieldname = (name, sema) => {
  let field_sect = '_VISAK';
  if (sema && Array.isArray(sema.fields)) {
    const sema_fields = [
      ...sema.fields
    ];
    sema_fields.forEach((field) => {
      if (typeof field === 'string') {
        if (field === name) {
          field_sect = sect.SECT_OWN;
        }
      } else {
        if (field.name === name) {
          field_sect = field.sect;
        }
      }
    });
    if (js_utils.is_object(sema.fixed_fields)) {
      Object.keys(sema.fixed_fields).forEach((key) => {
        if (key === name) {
          field_sect = sect.SECT_FIXED;
        }
      });
    }
  }
  return field_sect;
};


export const _podeli_virtel_na_sections = (virtel, sema) => {
  /*
  ova funkcija vrsi prepakivanej svih propertija virtuelnog itema u sect-ove na osnovu kojih backend moze lako da odredi genuse i sta ide u instance.
  */
  let _used_keys = {};
  let zapakovano = {
    sect_header: {
      // flag_is_virtel: true,
      thisis: 'VIRTEL'
    },
    sect_db: {},
    sect_instance: {},
    sect_genus: {},
    sect_fixed: {},
    sect_frontend: {},
    sect_NESVRSTANI: {}, // ???
  };
  // _used_keys.flag_is_virtel = true;
  // _used_keys.thisis = true;
  if (!Array.isArray(sema.fields)) {
    return {
      sect_header: {
        flag_is_virtel: true,
        thisis: 'VIRTEL',
        __UPOZORENJE__: 'Nije primljena validna sema. Proverite da niste poslali sema key umestio seme',
        ___TEMP: '' + virtel.virtelschemakey,
      }
    };
  }

  //
  let field_name = null;
  let field_sect;

  sema.fields.forEach((field) => {
    field_sect = null;
    if (js_utils.is_object(field)) {
      // sect je definisan
      field_name = field.name;
      if (field.sect) {
        field_sect = field.sect;
        zapakovano[field_sect][field_name] = virtel[field_name];
        _used_keys[field_name] = true; // setujemo bas true da bi lakse detektovalai viskove malo kasnije
      }
    }
  });
  // na kraju fixed_fields
  if (js_utils.is_object(sema.fixed_fields)) {
    field_sect = sect.SECT_FIXED;
    Object.keys(sema.fixed_fields).forEach((field_name) => {
      zapakovano[field_sect][field_name] = sema.fixed_fields[field_name];
      _used_keys[field_name] = true;
    });
  };
  // DODTANI KORAK provera da li objekat poseduje vise polja nego sema
  let visak_polja = false;
  let item_keys = Object.keys(virtel);
  // console.log(item_keys);
  // console.log(_used_keys);
  item_keys.forEach((key) => {
    if (_used_keys[key] !== true) {
      // ukoliko nije bas true znaci da je visak
      visak_polja = true;
      if ('_VISAK' in zapakovano) {
        zapakovano._VISAK[key] = virtel[key];
      } else {
        zapakovano._VISAK = {};
        zapakovano._VISAK[key] = virtel[key];
      }
    }
  });
  // console.log(zapakovano._VISAK);
  if (visak_polja === true) {
    zapakovano.sect_header._UPOZORENJE = 'Višak polja u odnosu na šemu!';
  }
  return zapakovano;
};

export const _sort_virtel_sect_keys = (keys, sorted_keys_arr) => {
  if (Array.isArray(keys) && Array.isArray(sorted_keys_arr)) {
    const sorted_keys = keys.sort((a, b) => {
      if (sorted_keys_arr.includes(a) && sorted_keys_arr.includes(b)) {
        // prioroty keys
        return sorted_keys_arr.indexOf(a) - sorted_keys_arr.indexOf(b);
      } else {
        if (sorted_keys_arr.includes(a)) {
          // priority key is A
          return -1;
        } else if (sorted_keys_arr.includes(b)) {
          // priority key is B
          return 1;
        } else {
          // other keys not sorted
          return 0;
        }
      }
    });
    return sorted_keys;
  } else {
    return keys;
  }
};




const OLD_compareArrayWithGenus = (items, genus_list, _genus_counter) => {

  // TODO PROBLEM razliciti tipovi genusa moraju da budu u razlicitim tabelama, sta kad su potrebni svi da se porede sa nizom raznolikih itema...?

  // TODO: zavisno od tipa itema, vrsi se poredjenje sa odredjenim tipom genusa...

  // TODO: potrebno i upozorenje na kraju da ???

};



// ----------------------------------------------------------------

export const _proba_pack_item = () => {
  /*
  IDEJA da postoji sema/definicja koji properti ide u koji PODS a da funkcija prima PROPERTI NAME kao argument i da na osnovu seme odluci iz kojeg secta ce da ga uzme
 
  to bi resilo mnogo problema sa virtuelizacijom.
  potencijalni porblem bi moga oda bude samo kucanje propertija... mozda bi morali da se kucaju kao string pod navodnicima sto moze da bude problem 
   a opet mozda se mogu napraviti pomocne 
  */

};

